import { render, staticRenderFns } from "./navmarketing.vue?vue&type=template&id=58e8b20a&scoped=true"
import script from "./navmarketing.vue?vue&type=script&lang=js"
export * from "./navmarketing.vue?vue&type=script&lang=js"
import style1 from "./navmarketing.vue?vue&type=style&index=1&id=58e8b20a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e8b20a",
  null
  
)

export default component.exports